import { gql } from '@apollo/client';

export const createUser = gql`
  mutation createUser(
    $isDevTeam: Boolean
    $name: String!
    $adId: String!
    $active: Boolean
    $mailStop: String
    $emailAddress: String
    $sendEmail: Boolean
    $applicationUserRoles: [ApplicationUserRoleInput!]!
  ) {
    createUser(
      user: {
        name: $name
        adId: $adId
        active: $active
        mailStop: $mailStop
        isDevTeam: $isDevTeam
        sendEmail: $sendEmail
        emailAddress: $emailAddress
        applicationUserRoles: $applicationUserRoles
        theme: "default"
      }
    )
  }
`;
